import { createAction } from 'redux-actions';

export const sortServiceTagsAction = createAction('DASHBOARD/SORT_SERVICETAGS');
export const searchServiceTagsAction = createAction('DASHBOARD/SEARCH_SERVICETAGS');
export const requestGetServiceTagsAction = createAction('REQUEST/GET_SERVICETAGS');
export const requestDeleteServiceTagAction = createAction('REQUEST/DELETE_SERVICETAG');
export const requestGetServiceTagByIdAction = createAction('REQUEST/GET_SERVICETAG_BY_ID');
export const requestUpdateServiceTagAction = createAction('REQUEST/PUT_SERVICETAG');
export const requestPostServiceTagAction = createAction('REQUEST/POST_SERVICETAG');
